import { Menu, MenuItem } from "@mui/material"
import { cloneElement, useEffect, useLayoutEffect, useRef } from "react"
import { useLocation, useRoute } from "wouter"
import schemes from "../../schemes"
import appStore from "../../store"

type AppMenuProps = {
  children: React.ReactNode,
  open: boolean,
  onClose: () => void
}

const AppMenu = ({ children, open, onClose }: AppMenuProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [ match, params ] = useRoute("/:project_id");
  const [ location, setLocation ] = useLocation(); 

  const handleClick = (key: string) => {
    setLocation("/"+key)
    onClose()
  }

  const key = params?.project_id
  useLayoutEffect(() => {
    if (key && key in schemes) {
      appStore.setScheme(key as any)
    }
  }, [ key ])

  return (
    <>
      { cloneElement(children as any, { ref }) }
      <Menu
        id="basic-menu"
        anchorEl={ref.current}
        open={open}
        onClose={onClose}
        
        PaperProps={{
          style: { width: 200 }
        }}
        sx={{ 
          '.MuiMenuItem-root': { height: 50, fontWeight: 700, color: 'text.secondary'  },
          '.Mui-selected': { color: 'text.primary' }
        }}
      >     
        {Object.keys(schemes).map(key => (
          <MenuItem onClick={() => handleClick(key)} key={key} selected={key === appStore.currentScheme}>
            {(schemes as any)[key].name}
          </MenuItem>
        ))}
      </Menu>
    </>
  )

}

export default AppMenu